import { TextField, styled } from '@mui/material';

export const StyledCreateStepsStep1TextWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	width: '100%',
	paddingInline: '8px',
}));

export const StyledCreateStepsStep1TextField = styled(TextField)({
	'& .MuiInputBase-root': {
		background: 'transparent',
		boxShadow: 'none',
	},

	'& .MuiInputBase-input': {
		paddingInline: '12px',
	},
});
